import { Signal, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { UntypedFormGroup } from '@angular/forms';
import { Fill, Stroke, Style } from 'ol/style';

type ObjectConstraint = { [key: string]: any };

export function generateComputedModel<T extends ObjectConstraint>(
  baseModel: T,
  form: UntypedFormGroup
): Signal<T> {
  const changes: Signal<any> = toSignal(form.valueChanges);

  return computed(() => {
    let _updatedModel = { ...baseModel };

    if (changes() == null) {
      return _updatedModel;
    }

    Object.keys(_updatedModel).forEach((key) => {
      (_updatedModel as any)[key] = changes()[key];
    });

    return _updatedModel;
  }, {});
}

export function convertToTitleCase(txt: string): string {
  if (txt === '') {
    return '';
  }
  return txt
    .toLowerCase()
    .split(' ')
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(' ');
}

export function defaultHazardStyle(): Style {
  return new Style({
    fill: new Fill({
      color: 'rgba(236,131,145,0.5)',
    }),
    stroke: new Stroke({
      color: 'rgb(255,16,16)',
      width: 2,
    }),
  });
}
